/* eslint-disable max-len */
export var populateAffiliatesLists = function populateAffiliatesLists(state) {
  return function (index) {
    return state.all.filter(function (entry, i) {
      return i % 2 === index;
    });
  };
};